export default "__VITE_ASSET__af62e192__"